import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import { ctaPurpleRight } from '../../assets/hostedassets';
import { useAppSelector } from '../../app/hooks';
import { Mixpanel } from '../../utils/mixpanel';
import { AICA_AUDITOR_COMMENTS_PILL_CLICKED } from '../../utils/constants/mixpanelEvents/investorEvents';
import { fetchVendorSourceMap } from '../../store/user/userV2/actions';
import AuditorCommentsDrawer from '../../modules/Dashboard/DashboardModules/AuditedFinancialsVisualisation/AuditorCommentsDrawer/AuditorCommentsDrawer';
import styles from './AuditorCommentsPill.module.scss';
import { AUDITED_FINANCIALS_VENDOR_PROBE } from '../../utils/constants/commonConstants';

interface AuditorCommentsPillProps {
    orgId: string;
    variant?: 'shimmer' | 'solid';
    hasConsolidated?: boolean;
    hasStandalone?: boolean;
}

const AuditorCommentsPill: React.FC<AuditorCommentsPillProps> = ({
    orgId,
    variant = 'shimmer',
    hasConsolidated = false,
    hasStandalone = false,
}) => {
    const dispatch = useDispatch();
    const [showDrawer, setShowDrawer] = useState(false);
    const user = useAppSelector((state) => state.user);
    const vendorSourceMap = useAppSelector((state) => state.user.vendorSourceMap);
    const auditedVendors: string[] = vendorSourceMap?.AUDITED_FINANCIALS || [];
    const showPill = auditedVendors.length > 0 && auditedVendors.includes(AUDITED_FINANCIALS_VENDOR_PROBE);

    useEffect(() => {
        if (!vendorSourceMap && user?.userData?.investorOrgId) {
            dispatch(
                fetchVendorSourceMap({
                    investorOrgId: user.userData.investorOrgId,
                    modules: ['AUDITED_FINANCIALS'],
                }),
            );
        }
    }, [dispatch, vendorSourceMap, user?.userData?.investorOrgId]);

    if (!showPill || !orgId) return null;

    return (
        <>
            <div
                className={clsx(styles.AuditorCommentsPill, { [styles.Solid]: variant === 'solid' })}
                onClick={() => {
                    Mixpanel.track(AICA_AUDITOR_COMMENTS_PILL_CLICKED, {
                        role: user?.userData?.accountType,
                        userId: user?.userData?.userId,
                        companyOrgId: orgId,
                        investorOrgId: user?.userData?.investorOrgId,
                        userEmail: user?.userData?.primaryEmail,
                        currentUrl: window.location.href,
                    });
                    setShowDrawer(true);
                }}
            >
                <img src={ctaPurpleRight} alt="" />
                Auditor&apos;s Comments
            </div>
            {showDrawer && <AuditorCommentsDrawer orgId={orgId} onClose={() => setShowDrawer(false)} />}
        </>
    );
};

export default AuditorCommentsPill;
